import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="nk-footer bg-white">
      <div className="container-fluid">
        <div className="nk-footer-wrap">
          <div className="nk-footer-copyright d-none d-md-block">
            &copy; 2025 Fuel Platform by Roadex.
          </div>
          {/* <div className="nk-footer-links">
            <ul className="nav nav-sm fs-10px md-fs-auto">
              <li className="nav-item nav-link">&copy; 2024 Fuel Platform </li>{" "}
              <li className="nav-item">
                <Link
                  // to={`${process.env.PUBLIC_URL}/terms-and-conditions`}
                  className="nav-link"
                >
                  Terms and conditions
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  // to={`${process.env.PUBLIC_URL}/privacy-policy`}
                  className="nav-link"
                >
                  Privacy policy
                </Link>
              </li>
              {<li className="nav-item">
                <Link
                  to={`${process.env.PUBLIC_URL}/pages/terms-policy`}
                  className="nav-link"
                >
                  Help
                </Link>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </div>
  );
};
export default Footer;
